export default {
  code: 'bg',
  meta: {
    title: 'Нановица, България – Пътеводител към Татул, Момчилград и Кърджали',
    description:
      'Пътеводител за село Нановица, община Момчилград, област Кърджали: факти, история, снимки, интерактивна карта и забележителностите наблизо – светилището на Орфей край Татул, Момчилград, Кърджали, Перперикон и още.',
    keywords:
      'Нановица, село Нановица, Татул, светилището на Орфей, Момчилград, Кърджали, Перперикон, Източни Родопи, българско село',
    ogTitle: 'Нановица – пътеводител към Татул, Момчилград и Кърджали',
    ogDescription:
      'Факти, история, снимки и интерактивна карта на Нановица и забележителностите наблизо в Източните Родопи.',
    twitterTitle: 'Нановица – пътеводител, България',
    twitterDescription:
      'Факти, история, снимки и интерактивна карта на Нановица и забележителностите наблизо в Източните Родопи.',
    schemaPlaceDescription:
      'Село в община Момчилград, област Кърджали, в Източните Родопи, близо до тракийското светилище край Татул.',
    schemaTatulName: 'Татул – тракийско светилище на Орфей',
    schemaTatulDescription:
      'Тракийско светилище със следи от заселване отпреди около 4000 г. пр.Хр., свързвано с култа към Орфей, край село Татул, община Момчилград.',
  },
  nav: {
    overview: 'Общ преглед',
    explore: 'Разгледайте',
    history: 'История',
    places: 'Места',
    map: 'Карта',
    gallery: 'Галерия',
    news: 'Новини',
  },
  hero: {
    eyebrow: 'Област Кърджали · България',
    lead: 'Село в Източните Родопи – и пътеводител към съседите му: тракийското светилище край Татул, град Момчилград и областния град Кърджали.',
    exploreBtn: 'Разгледайте района',
    mapBtn: 'Вижте картата',
    stats: { elevation: 'Надм. височина', population: 'Население (2021)', area: 'Площ', postal: 'Пощ. код' },
  },
  overview: {
    kicker: '01 · Общ преглед',
    title: 'Село сред хълмовете на Източните Родопи',
    paragraphs: [
      'Нановица е село в община Момчилград, област Кърджали – най-южната българска област, граничеща с Гърция.',
      'Източните Родопи около селото са ландшафт от полегати вулканични хълмове, древни тракийски светилища и смесено българско и турско население. При преброяването през 2011 г. 66,2 на сто от населението на областта се самоопределя като турци и 30,2 на сто – като българи. Районът е и убежище за дивата природа: почти всички европейски видове хищни птици обитават Източните Родопи, включително редките черен лешояд и египетски лешояд.',
      'Самата Нановица е малка – 456 жители през 2021 г. – но се намира сред забележително обкръжение. Тракийското светилище край Татул е в съседното село, град Момчилград е местният административен център, а Кърджали, областният град, е портата към Перперикон и язовирите по река Арда.',
    ],
    note: 'Да не се бърка с едноименно село в област Ловеч, закрито като населено място на 24 февруари 2007 г.',
    panelTitle: 'От Нановица',
    panelNote: 'Въздушно разстояние и посока, не по път.',
  },
  explore: {
    kicker: '02 · Разгледайте',
    title: 'Четири места, един пейзаж',
    lead: 'Превключвайте между селото и трите най-близки до него ориентира.',
    areas: [
      {
        id: 'nanovitsa',
        label: 'Нановица',
        kicker: 'Селото',
        title: 'Нановица',
        lead: 'Малко планинско село с около 450 жители в Източните Родопи, със собствено кметство в община Момчилград.',
        paragraphs: [
          'Нановица се намира на около 308 метра надморска височина и заема площ от около 5,2 квадратни километра. При преброяването през 2021 г. е имало 456 жители. Табелите на входа на селото са изписани на кирилица и латиница, а пощенският код е 6830.',
          'До 30 май 1913 г. районът е под османска власт, а на 10 август 1913 г., след Балканските войни, Нановица преминава под българска администрация. Днес то е кметство в община Момчилград.',
          'Селото граничи със съседните населени места Неофит Бозвелиево, Лале и Джелепско, обозначени с пътни знаци на изхода на селото. Околността предлага ловна база и язовир за риболов, а тракийското светилище край Татул е само на кратко разстояние.',
        ],
        note: 'Да не се бърка с едноименно село в област Ловеч, закрито като населено място на 24 февруари 2007 г.',
        facts: [
          ['Област', 'Кърджали'],
          ['Община', 'Момчилград'],
          ['Надм. височина', '308 м'],
          ['Площ', '5,2 км²'],
          ['Население', '456 (2021)'],
          ['Пощ. код', '6830'],
        ],
      },
      {
        id: 'tatul',
        label: 'Татул',
        kicker: 'Тракийско светилище',
        title: 'Татул и светилището на Орфей',
        lead: 'Село с каменни къщи до едно от най-значимите старинни светилища в Източните Родопи.',
        paragraphs: [
          'Татул е село в община Момчилград, на 319 метра надморска височина. Името му идва от местната българска дума за татул (Datura stramonium), а повечето къщи са изградени от добре одялани каменни блокове. През 2005 г. в него е имало 189 жители.',
          'Над селото се извисява древно тракийско светилище. Следи от заселване датират от около 4000 г. пр.Хр., а светилището е било в непрекъсната употреба от XIX–XVIII век пр.Хр. Археолозите са открили от този период около 30 глинени олтара, идол от желязната епоха във вид на гола мъжка фигура и каменен саркофаг на важен тракийски владетел.',
          'Между IV и I век пр.Хр. около хълма е изградена каменна стена, последвана скоро от храм и мавзолей. През II–III век сл.Хр. са добавени още постройки. В края на IV или началото на V век обектът е превърнат в християнско владение с отбранителна кула, а земетресения го увреждат през XII век пр.Хр. и през XIV век сл.Хр.',
          'Ръководителят на разкопките Николай Овчаров тълкува обекта като светилище и гробница на влиятелен тракийски владетел, обожествен след смъртта си, и го свързва с култа към Орфей. Обектът се превръща в туристическа дестинация с обновена инфраструктура, а от селото тръгва пътека към Вкаменената гора.',
        ],
        facts: [
          ['Надм. височина', '319 м'],
          ['Координати', '41°33′13″с.ш. 25°32′28″и.д.'],
          ['Население', '189 (2005)'],
          ['От Нановица', null],
          ['Най-ранно заселване', 'ок. 4000 г. пр.Хр.'],
          ['Светилището в употреба', 'от XIX–XVIII в. пр.Хр.'],
        ],
      },
      {
        id: 'momchilgrad',
        label: 'Момчилград',
        kicker: 'Най-близкият град',
        title: 'Момчилград',
        lead: 'Град с около 7800 жители и административен център за Нановица, с турско мнозинство и дълго османско минало.',
        paragraphs: [
          'Момчилград се намира на 452 метра надморска височина в Източните Родопи. При преброяването през 2011 г. е имал 7831 жители и е най-голямото българско селище с турско мнозинство – около 75 на сто от населението.',
          'До 1934 г. градът се е наричал Мастанли; турското население и днес го нарича Местанлъ. След Първата балканска война преминава към България и е преименуван на Момчил – историческа личност. Историческата му джамия с два минарета се използва от около 300 години.',
          'Музеят в Момчилград, основан през 1969 г. на улица „Момчил войвода“ №2, е първият по рода си в област Кърджали и днес показва около 1200 археологически, етнографски и природонаучни експоната. Момчилград е и родно място на плувеца Петър Стойчев, държал рекорда за най-бързо преплуване на Ламанша до 2012 г., както и на щангиста Наим Сюлейманоглу (1967–2017).',
          'Община Момчилград заема 358,12 квадратни километра и включва града и 54 села, сред които Нановица. През 2011 г. в нея са живели 16 263 души.',
        ],
        facts: [
          ['Надм. височина', '452 м'],
          ['Население', '7831 (2011)'],
          ['По-старо име', 'Мастанли, до 1934 г.'],
          ['От Нановица', null],
          ['Община', '358,12 км², 55 населени места'],
          ['Пощ. код', '6800'],
        ],
      },
      {
        id: 'kardzhali',
        label: 'Кърджали',
        kicker: 'Областният град',
        title: 'Кърджали',
        lead: 'Най-големият град на Източните Родопи и административен център на най-южната българска област.',
        paragraphs: [
          'Кърджали е разположен на двата бряга на река Арда, на 275 метра надморска височина, на около 260 километра югоизточно от София. Градът е имал 44 071 жители през 2011 г. и 40 659 през 2021 г.; по-голямата община, включваща 117 села, е имала 67 846 жители през 2011 г.',
          'Името идва от „Кърджа Али“, турски хайдутин от XVIII век. Османското владичество приключва на 21 октомври 1912 г., когато българският генерал Васил Делов освобождава града по време на Първата балканска война.',
          'Някога център на тютюнопреработването, днес икономиката на Кърджали разчита предимно на търговия и услуги, докато делът на заетите в земеделието расте. Сред най-известните забележителности са Регионалният исторически музей, язовирите Кърджали и Студен кладенец и древният скален град Перперикон, на около 15 километра северноизточно. Климатът е преходно-средиземноморски с горещи лета, с рекордна температура от 43,2 °C.',
          'Област Кърджали заема 3209,1 квадратни километра и граничи с Гърция. Тя включва седем общини – Ардино, Черноочене, Джебел, Кърджали, Кирково, Крумовград и Момчилград – и е имала 141 177 жители през 2021 г. Възстановена е като самостоятелна област през 1999 г., след като от 1987 г. е била част от област Хасково.',
        ],
        facts: [
          ['Надм. височина', '275 м'],
          ['Население (град)', '40 659 (2021)'],
          ['Площ (област)', '3209,1 км²'],
          ['От Нановица', null],
          ['Река', 'Арда'],
          ['Общини', '7 в областта'],
        ],
      },
    ],
  },
  numbers: {
    title: 'Районът в цифри',
    cards: [
      {
        id: 'nanovitsa',
        name: 'Нановица',
        role: 'Село',
        value: 456,
        caption: 'жители, 2021',
        rows: [
          ['Надм. височина', '308 м'],
          ['Площ', '5,2 км²'],
        ],
      },
      {
        id: 'momchilgrad',
        name: 'Момчилград',
        role: 'Град и седалище на общината',
        value: 7831,
        caption: 'жители, 2011',
        rows: [
          ['Надм. височина', '452 м'],
          ['Община', '16 263 жители'],
        ],
      },
      {
        id: 'kardzhali',
        name: 'Кърджали',
        role: 'Областен град',
        value: 40659,
        caption: 'жители, 2021',
        rows: [
          ['Надм. височина', '275 м'],
          ['Община', '67 846 жители (2011)'],
        ],
      },
      {
        id: 'kardzhali-province',
        name: 'Област Кърджали',
        role: 'Най-южната българска област',
        value: 141177,
        caption: 'жители, 2021',
        rows: [
          ['Площ', '3209,1 км²'],
          ['Общини', '7'],
        ],
      },
    ],
  },
  timeline: {
    kicker: '03 · История',
    title: 'Седем хиляди години сред хълмовете',
    lead: 'От първите заселници по скалистите хълмове до съвременното преброяване – филтрирайте по място, за да проследите една нишка.',
    filters: [
      { id: 'all', label: 'Всичко' },
      { id: 'tatul', label: 'Татул' },
      { id: 'perperikon', label: 'Перперикон' },
      { id: 'nanovitsa', label: 'Нановица' },
      { id: 'momchilgrad', label: 'Момчилград' },
      { id: 'kardzhali', label: 'Кърджали' },
    ],
    items: [
      { id: 'perperikon-first-activity', when: 'ок. 5000 г. пр.Хр.', title: 'Първи следи от живот в Перперикон', text: 'Следи от хора по скалистия хълм североизточно от Кърджали датират от около 5000 г. пр.Хр.' },
      { id: 'tatul-earliest-settlement', when: 'ок. 4000 г. пр.Хр.', title: 'Най-ранно заселване край Татул', text: 'Най-старите следи от заселване по хълма над село Татул.' },
      { id: 'tatul-sanctuary-in-use', when: 'XIX–XVIII в. пр.Хр.', title: 'Светилището е в употреба', text: 'От този период в светилището са открити около 30 глинени олтара; то остава в употреба векове наред.' },
      { id: 'perperikon-medokos', when: '424 г. пр.Хр.', title: 'Медокос се провъзгласява за цар', text: 'След смъртта на Ситалк, Медокос се провъзгласява за тракийски цар от Перперикон, но по-късно е свален.' },
      { id: 'tatul-wall', when: 'IV–I в. пр.Хр.', title: 'Стена обгражда светилищния хълм', text: 'Около хълма е изградена каменна стена, последвана скоро от храм и мавзолей.' },
      { id: 'tatul-new-buildings', when: 'II–III в. сл.Хр.', title: 'Нови постройки в Татул', text: 'През римската епоха към светилищния комплекс се добавят още сгради.' },
      { id: 'tatul-christian-period', when: 'края на IV/нач. на V в. сл.Хр.', title: 'Християнският период', text: 'Светилището край Татул е превърнато в християнско владение с отбранителна кула; християнски елементи се появяват и в Перперикон.' },
      { id: 'perperikon-fortress-ends', when: 'XIV век', title: 'Краят на средновековната крепост', text: 'До този момент Перперикон служи като средновековна крепост. Земетресение уврежда през XIV век и светилището край Татул.' },
      { id: 'ali-bey-house', when: '1851 г.', title: 'Къщата на Али бей', text: 'В село Манчево, днес в община Момчилград, е построена къща.' },
      { id: 'kardzhali-liberated', when: '21 октомври 1912 г.', title: 'Кърджали е освободен', text: 'Османското владичество в Кърджали приключва, когато генерал Васил Делов освобождава града по време на Първата балканска война.' },
      { id: 'nanovitsa-joins-bulgaria', when: '30 май – 10 август 1913 г.', title: 'Нановица преминава към България', text: 'Османският контрол над района приключва на 30 май. На 10 август 1913 г. Нановица преминава под българска администрация.' },
      { id: 'momchilgrad-renamed', when: '1934 г.', title: 'Мастанли става Момчилград', text: 'Градът е официално преименуван на Момчилград, на името на Момчил, като заменя османското си име Мастанли.' },
      { id: 'kardzhali-reservoir-built', when: '1957–1963 г.', title: 'Строи се язовир Кърджали', text: 'Строежът на стената по река Арда започва през 1957 г., язовирът е открит през 1963 г., а работата продължава до 1976 г.' },
      { id: 'momchilgrad-museum-opens', when: '1969 г.', title: 'Отваря музеят в Момчилград', text: 'Основан е първият по рода си музей в област Кърджали, показващ днес около 1200 експоната.' },
      { id: 'stone-mushrooms-protected', when: '13 май 1974 г.', title: 'Каменните гъби са обявени за защитени', text: 'Скалните форми край Бели пласт са обявени за природна забележителност.' },
      { id: 'kardzhali-province-restored', when: '1999 г.', title: 'Възстановена е област Кърджали', text: 'След дванадесет години като част от област Хасково областта е учредена наново.' },
      { id: 'perperikon-excavations-begin', when: '2000 г.', title: 'Започват системни разкопки', text: 'Археологът Николай Овчаров започва системните разкопки на Перперикон, които продължават и днес.' },
      { id: 'nanovitsa-census-2021', when: '2021 г.', title: 'Преброяване: 456 жители', text: 'Преброяването през 2021 г. отчита 456 души, живеещи в Нановица.' },
    ],
  },
  places: {
    kicker: '04 · Места',
    title: 'Какво да видите около Нановица',
    lead: 'Древни градове, природни забележителности и исторически сгради в близост до селото. Разстоянията са въздушни, от Нановица.',
    categories: {
      village: 'Село',
      town: 'Град',
      ancient: 'Старинен обект',
      nature: 'Природа',
      water: 'Вода',
      heritage: 'Наследство',
    },
    filters: [
      { id: 'all', label: 'Всички места' },
      { id: 'ancient', label: 'Старинни обекти' },
      { id: 'nature', label: 'Природа' },
      { id: 'water', label: 'Вода' },
      { id: 'heritage', label: 'Наследство' },
      { id: 'town', label: 'Градове' },
    ],
    items: [
      {
        id: 'nanovitsa',
        name: 'Нановица',
        summary: 'Селото, на което е посветена тази страница, сред хълмовете на община Момчилград.',
        details: [],
      },
      {
        id: 'tatul',
        name: 'Татул и светилището на Орфей',
        shortName: 'Татул',
        summary: 'Съседно село с едно от най-известните тракийски светилища в Източните Родопи, свързвано с култа към Орфей.',
        details: [
          ['Надм. височина', '319 м'],
          ['Най-ранно заселване', 'ок. 4000 г. пр.Хр.'],
          ['Светилището в употреба', 'от XIX–XVIII в. пр.Хр.'],
          ['Християнски период', 'края на IV/нач. на V в. сл.Хр.'],
        ],
      },
      {
        id: 'perperikon',
        name: 'Перперикон',
        summary: 'Изсечен в скалите древен град върху хълм с височина 470 м, наричан най-голямото мегалитно съоръжение на Балканите.',
        details: [
          ['Местоположение', 'на около 15 км североизточно от Кърджали'],
          ['Заселване', 'от около 5000 г. пр.Хр.'],
          ['Крепостни стени', 'до 2,8 м дебелина'],
          ['Разкопки', 'системни от 2000 г., ръководени от Николай Овчаров'],
          ['По-късна употреба', 'средновековна крепост до XIV век'],
        ],
      },
      {
        id: 'petrified-forest',
        name: 'Вкаменената гора',
        summary: 'Защитена природна забележителност в долината Габаз дере край село Равен, с около 30-милионгодишни вкаменени дървета.',
        details: [
          ['Възраст', 'около 30 милиона години'],
          ['Произход', 'древна гора, частично затрупана при вулканично изригване'],
          ['Особеност', 'според съобщенията единствената подобна гора, в която стволовете все още стоят изправени'],
          ['Начални точки', 'Равен, Татул и Гургулица'],
        ],
      },
      {
        id: 'stone-mushrooms',
        name: 'Каменните гъби',
        summary: 'Скални форми във вид на гъби източно от Бели пласт, край пътя между Кърджали и Хасково.',
        details: [
          ['Размер', 'столчета и шапки до 2,5 м'],
          ['Скали', 'риолитови вулкански туфи от подводна вулканична дейност през палеоцена'],
          ['Цветове', 'розови столчета (клиноптилолит) и зелени шапки (селадонит)'],
          ['Статут', 'природна забележителност от 13 май 1974 г., на площ от 3 хектара'],
        ],
      },
      {
        id: 'kardzhali-reservoir',
        name: 'Язовир Кърджали',
        summary: 'Голям язовир на река Арда, предпочитан за риболов и отдих на открито, с 103,5-метрова арково-гравитачна стена.',
        details: [
          ['Площ', '16,07 км²'],
          ['Обем', '497,2 млн. м³ – вторият по големина в България'],
          ['Стена', '103,5 м височина, 402,89 м дължина; единствената арково-гравитачна стена в България'],
          ['Мощност', '122 MW от четири турбини'],
          ['Строителство', 'започнато 1957 г., открито 1963 г., работи до 1976 г.'],
          ['Забележителности', 'меандърът Завоя и руините на крепостта Патмос'],
        ],
      },
      {
        id: 'rock-niches',
        name: 'Скалните ниши край Неофит Бозвелиево и Лале',
        summary: 'Култов комплекс от скални ниши между селата Неофит Бозвелиево и Лале, две от които имат необичайни акустични свойства.',
        details: [
          ['Ниши', '11, на две нива'],
          ['Акустика', 'две ниши създават отчетливо ехо при звук пред тях'],
          ['Местоположение', 'на около 2 км от Неофит Бозвелиево, край Лале'],
        ],
      },
      {
        id: 'ali-bey-house',
        name: 'Къщата на Али бей, Манчево',
        summary: 'Историческа къща, построена през 1851 г. в село Манчево – запазен пример за архитектурата на региона от XIX век.',
        details: [
          ['Построена', '1851 г.'],
          ['Село', 'Манчево, на 647 м надм. височина'],
        ],
      },
      {
        id: 'borovets',
        name: 'Резерват „Боровец“',
        summary: 'Защитена горска територия край Равен, съхраняваща борова, дъбова, дива крушова и хвойнова растителност.',
        details: [['Опазва', 'борова, дъбова, дива крушова и хвойнова гора']],
      },
      {
        id: 'momchilgrad',
        name: 'Момчилград',
        summary: 'Най-близкият град и седалище на общината, с музей, основан през 1969 г., и джамия с два минарета.',
        details: [
          ['Надм. височина', '452 м'],
          ['Население', '7831 (2011)'],
          ['Музей', 'около 1200 археологически, етнографски и природонаучни експоната'],
        ],
      },
      {
        id: 'kardzhali',
        name: 'Кърджали',
        summary: 'Областният град, разположен на двата бряга на Арда, с регионален исторически музей. Перперикон е на около 15 км североизточно.',
        details: [
          ['Надм. височина', '275 м'],
          ['Население', '40 659 (2021)'],
          ['Разстояние от София', 'около 260 км югоизточно'],
        ],
      },
    ],
  },
  map: {
    kicker: '06 · Карта',
    title: 'Ориентирайте се в района',
    lead: 'Изберете място от списъка или докоснете маркер, за да видите на какво разстояние се намира от Нановица.',
    ariaMap: 'Интерактивна карта на Нановица и близките места',
    youAreHere: 'Вие сте тук',
    showAll: 'Покажи всички места',
    hint: 'Отбелязани са само места с публикувани координати. Картографски данни © сътрудници на OpenStreetMap.',
    distanceSuffix: 'от Нановица',
  },
  gallery: {
    kicker: '07 · Галерия',
    title: 'Пейзажът в снимки',
    lead: 'Кликнете върху снимка, за да я уголемите; използвайте стрелките за преминаване през снимките.',
    filters: [
      { id: 'all', label: 'Всички снимки' },
      { id: 'nanovitsa', label: 'Нановица' },
      { id: 'tatul', label: 'Татул' },
      { id: 'momchilgrad', label: 'Момчилград' },
      { id: 'kardzhali', label: 'Кърджали' },
      { id: 'region', label: 'Из региона' },
    ],
  },
  photos: {
    'village-minaret': { alt: 'Бял минарет се издига над дървета и червен керемиден покрив, зад него хълмове', caption: 'Минарето и червените керемидени покриви, зад тях родопските хълмове' },
    'village-sign': { alt: 'Пътен знак с надпис „Нановица / Nanovitsa“ на входа на селото', caption: 'Табелата на селото, на кирилица и латиница' },
    'village-view': { alt: 'Къщи в края на Нановица, погледнати през сух хълм', caption: 'Къщи в края на селото' },
    'village-road': { alt: 'Селски път с каменен парапет и къщи по хълма', caption: 'Пътят в края на селото' },
    'village-signpost': { alt: 'Сини пътни знаци, сочещи към Неофит Бозвелиево, Лале и Джелепско', caption: 'Пътни знаци към съседните села Неофит Бозвелиево, Лале и Джелепско' },
    'tatul-panorama': { alt: 'Изглед към залесените хълмове на Източните Родопи от светилището край Татул', caption: 'Изглед към Източните Родопи от светилището край Татул' },
    'tatul-niche': { alt: 'Голяма ниша, изсечена в скалата край Татул', caption: 'Ниша, изсечена в скалата' },
    'tatul-summit': { alt: 'Скалният връх на Татул със залесени хълмове в далечината', caption: 'Скалният връх на светилището' },
    'tatul-rock-niche': { alt: 'Ниша, изсечена във изветрялата скала край Татул', caption: 'Скална ниша в светилището край Татул' },
    'tatul-sanctuary': { alt: 'Скална ниша в светилището, на заден план хълмове', caption: 'Изсечена ниша с изглед към хълмовете' },
    'tatul-excavation': { alt: 'Светла разкрита скала под защитен покрив край Татул', caption: 'Разкрита скална повърхност под защитен покрив' },
    'momchilgrad-square': { alt: 'Огрян от слънце площад в Момчилград със сгради и дървета', caption: 'Главният площад на Момчилград' },
    'momchilgrad-center': { alt: 'Павираният централен площад на Момчилград с обществена сграда в далечния му край', caption: 'Павираният централен площад' },
    'kardzhali-museum': { alt: 'Регионалният исторически музей в Кърджали, каменна сграда с централна арка', caption: 'Регионалният исторически музей в Кърджали' },
    'kardzhali-view': { alt: 'Изглед към центъра на Кърджали с жилищни блокове и парк', caption: 'Центърът на Кърджали, погледнат отгоре' },
    'kardzhali-reservoir': { alt: 'Язовир Кърджали, лъкатушещ между залесени хълмове', caption: 'Язовир Кърджали на река Арда' },
    'perperikon-top': { alt: 'Скалният връх на Перперикон над залесени хълмове', caption: 'Скалният връх на Перперикон' },
    'perperikon-walls': { alt: 'Средновековна каменна кула в Перперикон на фона на залязващо небе', caption: 'Средновековна крепостна кула в Перперикон по залез' },
    'perperikon-complex': { alt: 'Голи скални тераси на археологическия комплекс Перперикон', caption: 'Скалните тераси на комплекса Перперикон' },
    'stone-mushrooms': { alt: 'Скална форма във вид на гъба върху светла почва', caption: 'Скална форма във вид на гъба край Бели пласт' },
    'stone-mushrooms-dusk': { alt: 'Скали във вид на гъби, очертани на фона на здрачното небе', caption: 'Каменните гъби по здрач' },
    'studen-kladenets-dam': { alt: 'Бетонна стена на язовир, под нея изтича вода', caption: 'Стената на язовир Студен кладенец' },
  },
  footer: {
    tagline: 'Информационна страница за село Нановица, община Момчилград, област Кърджали – и за местата около него.',
    sourcesTitle: 'Източници',
    photosTitle: 'Снимки и карти',
    photosText: 'Снимките са от Wikimedia Commons и се използват по лицензи Creative Commons или са обществено достояние; авторът и лицензът са посочени под всяка снимка. Картографски данни © сътрудници на OpenStreetMap. Разстоянията са приблизителни, по въздушна линия, изчислени по публикувани координати.',
    disclaimer: 'Данните са събрани от посочените по-горе публични източници и може да се променят; моля, проверете преди пътуване.',
  },
  common: {
    skip: 'Към съдържанието',
    menuOpen: 'Меню',
    menuClose: 'Затвори',
    backToTop: 'Нагоре',
    showDetails: 'Покажи детайли',
    hideDetails: 'Скрий детайли',
    readGuide: 'Пълният пътеводител →',
    enlargePrefix: 'Уголеми снимка:',
    showPhotoPrefix: 'Покажи снимка:',
    zoomHint: 'Уголеми',
    photoViewer: 'Преглед на снимки',
    closeViewer: 'Затвори прегледа на снимки',
    previousPhoto: 'Предишна снимка',
    nextPhoto: 'Следваща снимка',
    filterPlacesAria: 'Филтриране на местата по вид',
    filterPhotosAria: 'Филтриране на снимките по място',
    filterTimelineAria: 'Филтриране на хронологията по място',
    areasTablistAria: 'Места за разглеждане',
    straightLineTitle: 'Въздушно разстояние от Нановица',
    language: 'Език',
    directions: ['С', 'СИ', 'И', 'ЮИ', 'Ю', 'ЮЗ', 'З', 'СЗ'],
  },
  news: {
    kicker: '05 · Новини',
    title: 'Новини от община Момчилград',
    lead: 'Актуални заглавия от общината, към която принадлежи Нановица, с директна препратка към оригиналните статии на сайта на общината.',
    readMore: 'Прочетете в momchilgrad.bg',
    viewAll: 'Всички новини на momchilgrad.bg →',
    updated: 'Обновено',
    sourceNote: 'Показани са само заглавия и дати – пълния текст ще намерите на сайта на общината. Nanovitsa.com е независима информационна страница и не е свързана с общинската администрация.',
    untranslatedNote: 'Все още непреведено – показва оригиналното заглавие.',
  },
}
